import { ref } from "vue";

export const usePostApi = (endpoint) => {
  const data = ref(null);
  const error = ref(null);

  const fetchData = async (payload) => {
    // Clear previous state before each call
    error.value = null;
    data.value = null;

    try {
      const result = await $fetch("/api/strapi-post", {
        method: "POST",
        body: {
          endpoint,
          payload,
        },
      });

      if (!result?.data && !result) {
        throw new Error("Veri bulunamadı");
      }

      data.value = result;
    } catch (err) {
      // $fetch throws FetchError with nested data structure
      // Server API returns: { statusCode, statusMessage, data: { error: { message } } }
      const strapiMessage =
        err?.data?.data?.error?.message ||  // Strapi error inside server response data
        err?.data?.error?.message ||         // Direct error object
        err?.data?.statusMessage ||          // Server statusMessage
        err?.response?._data?.data?.error?.message ||
        err?.response?._data?.error?.message ||
        err?.statusMessage ||
        null;

      // Use Strapi message if available, otherwise provide a user-friendly fallback
      if (strapiMessage) {
        error.value = strapiMessage;
      } else {
        // Don't show raw HTTP errors like '[POST] "/api/strapi-post": 500'
        error.value = "Form gönderilemedi. Lütfen tekrar deneyin.";
      }

      console.error("[postApi] Error details:", {
        message: err?.message,
        statusCode: err?.statusCode,
        statusMessage: err?.statusMessage,
        data: err?.data,
      });

      data.value = null;
    }
  };

  return {
    data,
    error,
    fetchData,
  };
};
